'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*----------------------------
Scripts
----------------------------*/

document.addEventListener('DOMContentLoaded', function (event) {
  /*----------------------------
  Paragraphs
  ----------------------------*/
  var articleContentParagraphs = document.querySelectorAll('.article__content > p');

  // Loop through them to assign classes.
  [].concat((0, _toConsumableArray3.default)(articleContentParagraphs)).forEach(function (paragraph) {
    if (paragraph.querySelectorAll('img').length > 1) {
      paragraph.classList.add('article__images-paragraph');
    } else if (paragraph.querySelector('img')) {
      paragraph.classList.add('article__image-paragraph');
    } else if (paragraph.querySelector('video')) {
      paragraph.classList.add('article__video-paragraph');
    } else {
      paragraph.classList.add('article__text-paragraph');
    }
  });

  /*----------------------------
  Headers
  ----------------------------*/
  var articleContentHeaders = document.querySelectorAll('.article__content > h1, .article__content > h2, .article__content > h3, .article__content > h4, .article__content > h5');

  [].concat((0, _toConsumableArray3.default)(articleContentHeaders)).forEach(function (header) {
    header.classList.add('article__text-header');
  });

  /*----------------------------
  Line Spacers
  ----------------------------*/
  var articleContentLineSpacers = document.querySelectorAll('.article__content > h6');

  [].concat((0, _toConsumableArray3.default)(articleContentLineSpacers)).forEach(function (spacer) {
    spacer.innerText = '';
    spacer.classList.add('article__spacer');
  });

  /*----------------------------
  Blockquotes
  ----------------------------*/
  var articleContentBlockquotes = document.querySelectorAll('.article__content > blockquote');

  [].concat((0, _toConsumableArray3.default)(articleContentBlockquotes)).forEach(function (blockquote) {
    blockquote.classList.add('article__blockquote');
  });
});